import { useAuth } from 'shared/context/auth/useAuth.js';
import {
  DEFAULT_LOGGED_PAGE,
  DEFAULT_NOT_LOGGED_PAGE,
} from 'shared/routes.js';

type Login = (options?: { returnTo?: string }) => Promise<void>;

const withDefaultReturnTo = (login: Login): Login => (options = {}) =>
  login({ returnTo: options.returnTo ?? DEFAULT_LOGGED_PAGE });

export const useAppAuth = () => {
  const auth = useAuth();

  return {
    ...auth,
    login: withDefaultReturnTo(auth.login),
    loginDirect: withDefaultReturnTo(auth.loginDirect),
    logout: () =>
      auth.logout({
        redirectTo: DEFAULT_NOT_LOGGED_PAGE,
      }),
  };
};
